import React from 'react';

const UnionSymbol = () => {
	return (
		<>
			<div className="union-symbol">&#8899;</div>
		</>
	);
};

export default UnionSymbol;
